<div *ngIf="state === 'questionTransition'" class="transition" [ngStyle]="outerStyles">
  <div *ngIf="transitionContent" class="transition-content">
    {{ transitionContent }}
  </div>
</div>

<ms-text-container *ngIf="state !== 'questionTransition'">
  <div class="outer" [ngStyle]="outerStyles">
    <div *ngIf="state === 'idle'" class="idle">
      <div class="idle-title">
        <!-- Вопросы -->
        {{ 'speedReading.quiz.questions' | translate }}
      </div>
      <button class="idle-start" (click)="setNextQuestion()">
        <!-- Начать -->
        {{ 'speedReading.quiz.start' | translate }}
      </button>
    </div>

    <div class="content-container" *ngIf="isQuestioning" (click)="onQuestionClick()">
      <div class="question-wrapper">
        <div class="question-parent" [ngStyle]="questionWrapperStyle">
          <!-- msl-fit-text -->
          <div class="question" [ngClass]="{ 'question--shrink': state !== 'question' }">
            {{ activeQuestionIndex + 1 }}. {{ activeQuestion.question }}
          </div>
        </div>
      </div>

      <div class="delimiter" [ngStyle]="delimiter">
        <span class="delimiter-entry">.</span>
        <span class="delimiter-entry">.</span>
        <span class="delimiter-entry">.</span>
      </div>

      <div
        class="show-options-wrapper"
        *ngIf="state === 'question' && showOptionsManually"
        @fadeInOut
      >
        <!-- Нажмите, чтобы начать отвечать. -->
        <div class="show-options">{{ 'speedReading.quiz.showOptions' | translate }}</div>
      </div>

      <ol
        class="option-container"
        *ngIf="state === 'options' || state === 'result'"
        [ngStyle]="optionContainerStyle"
        [@optionFadeIn]="activeQuestion.options.length"
      >
        <li
          class="option"
          *ngFor="let option of activeQuestion.options; index as index"
          [ngStyle]="optionStyle"
          [ngClass]="{
            'option--selected': selectedOption === option,
            'option--correct': state === 'result' && option.isCorrect,
            'option--wrong': state === 'result' && !option.isCorrect && selectedOption === option
          }"
          (click)="selectOption(index)"
        >
          {{ option.text }}
        </li>
      </ol>

      <div class="result-container" *ngIf="state === 'result'">
        <div class="result" (click)="setNextQuestion()">
          <!-- Продолжить -->
          {{ 'speedReading.quiz.continue' | translate }}
        </div>
      </div>
    </div>
  </div>
</ms-text-container>
